import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { 
  createComponentConfig, 
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const PhotoRestoration = () => {
  const { t } = useI18n();

  // 创建老照片修复的配置
  const photoRestorationConfig = createComponentConfig({
    components: [
      createComponentItem({
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        id: 'oldPhoto',
        title: t('aiToolTemplate.uploadImage'),
        description: t('aiToolTemplate.uploadImageDescription'),
        required: true,
        props: {
          acceptedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
          maxSize: 10 * 1024 * 1024,
          preview: true,
          cropAspectRatio: null,
          placeholder: t('aiToolTemplate.clickOrDragUpload')
        },
        order: 1
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        id: 'coreRestoration',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'restoredImageCoreRestoration',
          allowMultiple: false
        },
        order: 3
      }),
      createComponentItem({
        id: 'colorOptions',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'restoredImageColorOptions',
          allowMultiple: false
        },
        order: 4
      }),
      createComponentItem({
        id: 'styleVibe',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'restoredImageStyleVibe',
          allowMultiple: false
        },
        order: 5
      }),
      createComponentItem({
        id: 'aiGenerative',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'restoredImageAiGenerative',
          allowMultiple: false
        },
        order: 6
      }),
      // createComponentItem({
      //   id: 'professionalControl',
      //   type: COMPONENT_TYPES.TAG_SELECTOR,
      //   required: false,
      //   props: {
      //     dictName: 'restoredImageProfessionalControl',
      //     allowMultiple: false
      //   },
      //   order: 7
      // }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'supplementaryPrompt',
        title: t('aiToolTemplate.supplementaryPrompt'),
        description: t('aiToolTemplate.supplementaryPromptDescription'),
        required: false,
        props: {
          placeholder: t('aiToolTemplate.enterSupplementaryPrompt')
        },
        order: 8
      }),
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.supplementaryPrompt;
      }
    },
    additionalParams: {
      model: 'nano',
      width: 1024,
      height: 1024,
      style: 'restoration'
    }
  });

  return (
    <AiToolTemplateV2
      toolName={t('aiToolTemplate.tools.photoRestoration.name')}
      toolIcon="📸"
      toolDescription={t('aiToolTemplate.tools.photoRestoration.description')}
      config={photoRestorationConfig}
      gradientColors={['#8B4513', '#D2691E']}
      toolId={TOOL_IDS.PHOTO_RESTORATION}
    />
  );
};

export default PhotoRestoration;
